export default "__VITE_ASSET__gO1ur8nH__"